import React from 'react';
import ReactDOM from 'react-dom/client';

//全局样式
import './index.css'
//根组件
import App from './App'


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);